var map = {
	"./3NP.png": "9129",
	"./4NP.png": "c6e9",
	"./5NP.png": "b00f",
	"./6NP.png": "7295",
	"./veza-2NP.png": "ed28",
	"./veza-3NP.png": "6b8a",
	"./veza-4NP.png": "af96",
	"./veza-5NP.png": "0f0c",
	"./veza-6NP.png": "d0a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2f7";